import { FINISH_LOADING, START_LOADING } from '.'

const loaderReducer = (state, action) => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case FINISH_LOADING:
      return {
        ...state,
        loading: false
      }
    default:
      return state
  }
}

export { loaderReducer }
